export interface OriginalResponseError {
  tag: string
  error: any
}

export enum WalletParamName {
  SOLANA = 'solana_wallet_address',
  ETHEREUM = 'wallet_address'
}
